module.exports = __webpack_public_path__ + "assets/img/C-3.fb44124f.jpg";